import React, { useEffect, useState } from "react";
import axios from "axios";
import { Box, Typography, Slide, Snackbar } from "@mui/material";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";

const AdminAlerts = () => {
    const [counts, setCounts] = useState({ deposit: 0, withdraw: 0, chat: 0 });
    const [alertQueue, setAlertQueue] = useState([]);
    const [currentAlert, setCurrentAlert] = useState(null);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        let isMounted = true;
        
        const fetchAlerts = async () => {
            try {
                const token = localStorage.getItem("user");
                if (!token) return;
                
                // Sử dụng interceptor của axios nếu đã được cấu hình trong App, hoặc gọi trực tiếp với header
                const res = await axios.get(`${process.env.REACT_APP_API_URL}/statistic/alerts`, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                
                if (res.data.success && isMounted) {
                    const data = res.data.data;
                    
                    let newAlerts = [];
                    // So sánh để trigger popup. Khởi tạo counts = 0 nên lần đầu fetch sẽ không nhảy popup (tránh nhảy popup spam lúc mới load trang)
                    if (counts.deposit !== 0 && data.deposit > counts.deposit) {
                        newAlerts.push({ type: 'deposit', title: 'New Deposit!', msg: 'Có yêu cầu nạp điểm mới', color: 'linear-gradient(135deg, #FF6B6B, #FF8E53)' });
                    }
                    if (counts.withdraw !== 0 && data.withdraw > counts.withdraw) {
                        newAlerts.push({ type: 'withdraw', title: 'New Withdrawal!', msg: 'Có yêu cầu rút điểm mới', color: 'linear-gradient(135deg, #4facfe, #00f2fe)' });
                    }
                    if (counts.chat !== 0 && data.chat > counts.chat) {
                        newAlerts.push({ type: 'chat', title: 'New Message!', msg: 'Có tin nhắn CSKH mới', color: 'linear-gradient(135deg, #43e97b, #38f9d7)' });
                    }
                    
                    if (newAlerts.length > 0) {
                        setAlertQueue((prev) => [...prev, ...newAlerts]);
                    }
                    
                    // Always update to current actual state (if we load the page, counts starts at actual data)
                    setCounts(data);
                }
            } catch (err) {
                console.error("Lỗi lấy thông báo:", err);
            }
        };

        const interval = setInterval(fetchAlerts, 10000); // Polling mỗi 10s
        fetchAlerts();

        return () => {
            isMounted = false;
            clearInterval(interval);
        };
    }, [counts]); // Phụ thuộc vào counts hiện tại để tính độ chênh lệch

    useEffect(() => {
        if (alertQueue.length > 0 && !currentAlert) {
            setCurrentAlert(alertQueue[0]);
            setAlertQueue((prev) => prev.slice(1));
            setOpen(true);
            
            // Tự đóng popup sau 4s
            setTimeout(() => {
                setOpen(false);
                setTimeout(() => {
                    setCurrentAlert(null);
                }, 500); // Chờ hiệu ứng Slide out
            }, 4000);
        }
    }, [alertQueue, currentAlert]);

    return (
        <Snackbar
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            open={open}
            TransitionComponent={Slide}
            sx={{ top: { xs: 20, sm: 20 }, zIndex: 99999 }}
        >
            <Box
                sx={{
                    background: currentAlert?.color || "linear-gradient(135deg, #FF6B6B, #FF8E53)",
                    borderRadius: "16px",
                    boxShadow: "0 8px 32px rgba(0, 0, 0, 0.2)",
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                    p: "12px 30px",
                    color: "#fff",
                    minWidth: "350px",
                    position: "relative",
                    overflow: "hidden",
                    "@keyframes glow": {
                        "0%": { boxShadow: "0 0 5px rgba(255,255,255,0.2)" },
                        "50%": { boxShadow: "0 0 20px rgba(255,255,255,0.6)" },
                        "100%": { boxShadow: "0 0 5px rgba(255,255,255,0.2)" }
                    },
                    animation: "glow 2s infinite ease-in-out"
                }}
            >
                <NotificationsActiveIcon sx={{ fontSize: 36, color: "#fff" }} />
                <Box>
                    <Typography variant="h6" fontWeight="bold" sx={{ lineHeight: 1.2 }}>
                        {currentAlert?.title}
                    </Typography>
                    <Typography variant="body2" sx={{ opacity: 0.9, mt: 0.5 }}>
                        {currentAlert?.msg}
                    </Typography>
                </Box>
            </Box>
        </Snackbar>
    );
};

export default AdminAlerts;
